<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <CostMaterialTransportationForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import CostMaterialTransportationForm from '@/components/reports/costmaterialtransportation/CostMaterialTransportationForm'

export default {
  name: 'AcessoryAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    CostMaterialTransportationForm
  }
}
</script>
